exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-80[data-v-26f01860]{margin-left:60px}.box-w-70[data-v-26f01860]{width:60px;height:90px;border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;text-align:center;line-height:80px;background:rgba(0,0,0,.2)}.box-w-70 img[data-v-26f01860]{width:50px}.detail-box[data-v-26f01860]{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgb(0 0 0/10%);border-radius:2px;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26f01860","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/realTimeMonitor/RealTimeMonitor.vue
// module id = 296
// module chunks = 0